
import { mapMutations } from 'vuex'
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import Zoom from "@/components/Zoom";

export default {
  components: { Zoom,ElImageViewer },
  props: {
    pageData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    id: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      indexBanner: [],
      btnObj: ["View larger", "3D Preview"],
      current3D: 0,  // 3D图序号
      btnShow: true, // 所有按钮显示
      bigShow: false,
      showViewer: false,
    };
  },
  computed: {
    currentPre(){
      return this.$store.state.product.smImgUlIdx
    },
    comInfo() {
      const { main } = this.pageData;
      const images = main.image_color.map(i => i.image); 

      if (main.image) {
        images.unshift(main.image);
      }

      main.mergeImages = images;
      return main;
    },

    comS3Img(){
			return this.comInfo.mergeImages.map(url => this.$utils.repaceDomain(url));
		}
  },
  watch:{
    currentPre(newVal){
      this.$refs.carousel.setActiveItem(newVal);
    }
  },
  mounted(){
    if(this.comInfo.video){
      this.$refs.video.volume = 0.5;
    }
  },
  methods: {
    ...mapMutations({ setSmImgUlIdx: 'product/setSmImgUlIdx' }),
    changeCarousel (val) {
      this.setSmImgUlIdx(val);
      if (val === this.comInfo.mergeImages?.length) {
        this.btnShow = false;
        this.comInfo.video && this.$refs.video.play();
      } else {
        this.btnShow = true;
        this.comInfo.video && this.$refs.video.pause();
      }
    },
    selectCurrent3D(val) {
      this.current3D = val;
    },
    getStyle(val) {
      const bigImg = this.$refs.big;
      bigImg.style.left = -2 * val.left + "px";
      bigImg.style.top = -2 * val.top + "px";
      this.bigShow = val.bigShow;
    },
    closeViewer() {
      this.showViewer = false;
    },
	handleViwer(){
		this.showViewer = true;
	}
  }
};
